import { FormErrors } from "./form-errors";
import { GalleryVerticalEnd } from "lucide-react";
import { Form, Link, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";
import { Spinner } from "@/components/ui/spinner";
import { Button } from "@/components/ui/button";
import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLabel,
} from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import { passwordsPath } from "@/routes";

export function ForgotPasswordForm({
  className,
  ...props
}: React.ComponentProps<"div">) {
  const { t } = useTranslation();
  const { app_name: appName, errors } = usePage().props;
  return (
    <div className={cn("flex flex-col gap-6", className)} {...props}>
      <Form action={passwordsPath()} method="post" disableWhileProcessing>
        {({ processing }) => (
          <FieldGroup>
            <FormErrors
              errors={errors}
              targets={{
                email_address: "email_address",
                password: "password",
                password_confirmation: "password_confirmation",
              }}
            />
            <div className="flex flex-col items-center gap-2 text-center">
              <Link
                href="/login"
                className="flex flex-col items-center gap-2 font-medium"
              >
                <div className="flex size-8 items-center justify-center rounded-md">
                  <GalleryVerticalEnd className="size-6" />
                </div>
                <span className="sr-only">{appName}</span>
              </Link>
              <h1 className="text-page font-display">
                {t("auth.reset_title")}
              </h1>
              <FieldDescription>
                {t("auth.no_account")}{" "}
                <Link href="/sign_up">{t("auth.signup")}</Link>
              </FieldDescription>
            </div>
            <Field>
              <FieldLabel htmlFor="email_address">{t("auth.email")}</FieldLabel>
              <Input
                id="email_address"
                name="email_address"
                type="email"
                autoComplete="email"
                placeholder="m@example.com"
                required
              />
            </Field>
            <Field>
              <Button
                type="submit"
                disabled={processing}
                aria-busy={processing}
              >
                {processing && <Spinner />}
                {t("auth.reset_submit")}
              </Button>
            </Field>
          </FieldGroup>
        )}
      </Form>
    </div>
  );
}
